import _ from 'lodash';
import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Box } from '@material-ui/core';
import { COLOR } from 'config/constants';
import { images } from 'assets/images';

const useStyles = makeStyles({
  pageTitle: {
    fontWeight: 'bold',
    marginBottom: 30,
    color: COLOR.BLACK,
  },
  subtitle: {
    color: COLOR.BLACK,
    marginBottom: 30,
    textAlign: 'center',
  },
});

interface Props {
  className: string;
}

function FormHeader({ className }: Props) {
  const styles = useStyles();
  const intl = useIntl();
  const fmtTitle = intl.formatMessage({ id: 'serviceRequest.title' });
  const fmtSubtitle = intl.formatMessage({ id: 'serviceRequest.subtitle' });
  return (
    <Box>
      <Typography variant='h4' className={styles.pageTitle}>
        {fmtTitle}
      </Typography>
      <Typography className={styles.subtitle}>{fmtSubtitle}</Typography>
    </Box>
  );
}

FormHeader.defaultProps = {
  className: null,
};

FormHeader.propTypes = {
  className: PropTypes.string,
};

export default FormHeader;
